module.exports = __webpack_public_path__ + "static/media/helpcenter.5dd0d318.png";